<button [type]="type" mat-raised-button [color]="color" (click)="onClick($event)">
    <mat-icon *ngIf="item.icon">{{item.icon_type}}</mat-icon>
    {{item.label}}
</button>